export function buildFormNumber(client) {
    const {country} = client;
    return `${country.code}${client.mobile_phone}`;
}